import React from "react";
import KBLearnMore from "../../../../components/learnMore/KBLearnMore";
import { ILEARN_URLS } from "../../../../constants/ilearnUrls";

const RevenueLearnMore = () => {
  return (
    <KBLearnMore
      title="Total Revenue"
      description="This report displays revenue across Services, Products, and Recurring billing in one comprehensive view. These insights help you understand revenue composition, track performance, and forecast more effectively."
      kbUrl={ILEARN_URLS.dashboard.totalRevenue}
    />
  );
};

export default RevenueLearnMore;
